import {
  useMemo,
} from 'react'

import {
  TopBar,
} from './components/TopBar'

import {
  LAIAWorkspace,
} from './features/laia/LAIAWorkspace'

import {
  ExtensionPanels,
} from './platform/layout/ExtensionPanels'

import {
  SessionElapsed,
} from './platform/layout/SessionElapsed'

import {
  ContextualSurface,
} from './platform/contextual/ContextualSurface'

import {
  useLayout,
} from './platform/preferences/LayoutContext'

import {
  loadSession,
  openLAIAWindow,
} from './services/genesisSession'

import './styles/genesis.css'
import './styles/r7-context.css'
import './styles/r7-wire.css'

export default function App() {
  const session =
    useMemo(
      loadSession,
      [],
    )

  const {
    preferences,
  } =
    useLayout()

  const params =
    useMemo(
      () =>
        new URLSearchParams(
          window.location.search,
        ),
      [],
    )

  const focused =
    params.get('view') ===
    'laia'

  if (focused) {
    return (
      <main className="focus">

        <ContextualSurface
          id="surface:laia"
          title="LAIA Génesis"
          allowHide={false}
          showMenu={false}
          className="r7-laia-surface"
        >
          <LAIAWorkspace
            session={session}
            focused
          />
        </ContextualSurface>

      </main>
    )
  }

  return (
    <div className="app">

      <TopBar
        onOpenLAIA={() =>
          openLAIAWindow(
            session
              .conversationSessionId,
          )
        }
      />

      <main
        className={[
          'workspace',

          preferences.designMode
            ? 'design-mode'
            : '',

          preferences.designLocked
            ? 'design-locked'
            : '',
        ]
          .filter(Boolean)
          .join(' ')}
      >

        <ExtensionPanels
          side="LEFT"
        />

        <section className="laia-zone">

          <ContextualSurface
            id="surface:laia"
            title="LAIA Génesis"
            allowHide={false}
            className="r7-laia-surface"
          >
            <LAIAWorkspace
              session={session}
            />
          </ContextualSurface>

        </section>

        <ExtensionPanels
          side="RIGHT"
        />

      </main>

      <footer className="status">

        <div>
          <span>
            ● Sistema ESTABLE
          </span>

          <span>
            SUPERVISED_FULL
          </span>

          <span>
            PRODUCCIÓN
          </span>

          <span>
            Genesis vNext
          </span>
        </div>

        <div className="session-elapsed-status">
          <SessionElapsed />
        </div>

      </footer>

    </div>
  )
}
